<template>
  <template v-if="!modStatus">
    <commonTable
      :fields="wireTableFields"
      :items="wireItem.slice(0, -1)"
      :otherTheme="'thead-green'"
      stickyHeader="447px"
    >
      <template #cell(index)="data">{{ data.index + 1 }}</template>
      <template #cell(code)="data">
        <template v-if="data.value == '' || data.value == null">-</template>
        <template v-else>{{ data.value }}</template>
      </template>
      <template #cell(chinese_name)="data">
        <template v-if="data.value == '' || data.value == null">-</template>
        <template v-else>{{ data.value }}</template>
      </template>
      <template #cell(furnaceCode)="data">
        <template v-if="data.value == '' || data.value == null">-</template>
        <template v-else>{{ data.value }}</template>
      </template>
      <template #cell(consumption)="data">{{
        data.value.toLocaleString("en-US")
      }}</template>
    </commonTable>
  </template>
  <template v-else>
    <commonTable
      :fields="wireTableFields"
      :items="wireItem"
      :otherTheme="'thead-green'"
      stickyHeader="447px"
      class="modWireTable"
    >
      <template #cell(index)="data">
        <template v-if="data.index + 1 != wireItem.length">
          {{ data.index + 1 }}
        </template>
      </template>
      <template #cell(scroll_no)="data">
        <template v-if="data.index + 1 != wireItem.length">
          <input
            type="text"
            @blur="checkChangeInput('scroll_no', data.index)"
            v-model="wireItem[data.index].scroll_no"
            style="width: 157px; height: 100%"
            class="text-center"
          />
        </template>
      </template>
      <template #cell(code)="data">
        <template v-if="data.index + 1 != wireItem.length">
          <template v-if="data.value == '' || data.value == null">-</template>
          <template v-else>{{ data.value }}</template>
        </template>
      </template>
      <template #cell(chinese_name)="data">
        <template v-if="data.index + 1 != wireItem.length">
          <template v-if="data.value == '' || data.value == null">-</template>
          <template v-else>{{ data.value }}</template>
        </template>
      </template>
      <template #cell(furnaceCode)="data">
        <template v-if="data.index + 1 != wireItem.length">
          <template v-if="data.value == '' || data.value == null">-</template>
          <template v-else>{{ data.value }}</template>
        </template>
      </template>
      <template #cell(consumption)="data">
        <template v-if="data.index + 1 != wireItem.length">
          <input
            type="text"
            @blur="checkChangeInput('consumption', data.index)"
            v-model="wireItem[data.index].consumption"
            style="width: 100%; height: 100%"
            class="text-center"
          />
        </template>
      </template>
      <template #cell(del)="data">
        <template v-if="data.index + 1 != wireItem.length">
          <button
            class="btn orderManagement-table-button px-2 py-0"
            @click="onWireDeleteClicked(data.index)"
          >
            刪除
          </button>
        </template>
        <template v-else>
          <button
            class="btn orderManagement-table-button px-2 py-0"
            @click="onWireAddClicked"
          >
            新增
          </button>
        </template>
      </template>
    </commonTable>
  </template>
</template>

<script>
import commonTable from "@/components/commonTable.vue";
import { computed, inject, ref, watch } from "vue";
import { useStore } from "vuex";
export default {
  name: "wireTable",
  components: {
    commonTable,
  },
  props: {
    wireItem: {
      type: Array,
      default: [],
    },
    reason: {
      type: Array,
      default: [],
    },
    modStatus: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const path = inject("path");

    //查詢結果表格
    const wireTableFields = ref([]);

    const setField = () => {
      if (props.modStatus == false) {
        wireTableFields.value = [
          {
            key: "index",
            label: "項次",
            thStyle: {
              "min-width": "55px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "scroll_no",
            label: "線材捲號",
            thStyle: {
              "min-width": "175px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "code",
            label: "線材品號",
            thStyle: {
              "min-width": "230px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "chinese_name",
            label: "線材品名",
            thStyle: {
              "min-width": "485px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "furnaceCode",
            label: "爐號",
            thStyle: {
              "min-width": "70px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "consumption",
            label: "耗用量(KG)",
            thStyle: {
              "min-width": "110px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
        ];
      } else if (props.modStatus == true) {
        wireTableFields.value = [
          {
            key: "index",
            label: "項次",
            thStyle: {
              "min-width": "55px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "scroll_no",
            label: "線材捲號",
            thStyle: {
              "min-width": "175px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "code",
            label: "線材品號",
            thStyle: {
              "min-width": "230px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "chinese_name",
            label: "線材品名",
            thStyle: {
              "min-width": "485px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "furnaceCode",
            label: "爐號",
            thStyle: {
              "min-width": "70px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "consumption",
            label: "耗用量(KG)",
            thStyle: {
              "min-width": "110px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
          {
            key: "del",
            label: "刪除",
            thStyle: {
              "min-width": "90px",
              "font-size": "16px",
            },
            tdStyle: {
              "font-size": "16px",
            },
          },
        ];
      }
    };

    const checkChangeInput = (position, index = null) => {
      switch (position) {
        case "scroll_no":
          console.log("scroll_no");
          let scroll_no = props.wireItem[index].scroll_no;
          if (scroll_no == "" || scroll_no == undefined) {
            props.wireItem[index].scroll_no =
              props.wireItem[index].orgScroll_no;
            methods.setTimeoutAlert(`線材捲號不可為空，請再次確認`);
            return;
          }
          for (let i = 0; i < props.wireItem.length - 1; i++) {
            if (i == index) {
              continue;
            }
            if (props.wireItem[i]["scroll_no"] == scroll_no) {
              props.wireItem[index].scroll_no =
                props.wireItem[index].orgScroll_no;
              methods.setTimeoutAlert(`線材捲號已存在，請再次確認`);
              return;
            }
          }
          var params = {};
          params["webPage"] =
            sideNavPath.value.length != 0
              ? sideNavPath.value[sideNavPath.value.length - 1]
              : null;
          params["user"] = loginData.value.account;
          params["vuePage"] = path.value;
          params["methods"] = "POST";
          params["scroll_no"] = scroll_no;
          params["whichFunction"] = "checkChangeInput";
          methods.axiosAction(params).then(() => {
            let result = axiosResult.value;
            console.log(result.QueryTableData);
            if (result["Response"] == "ok") {
              props.wireItem[index].code = result.QueryTableData.code;
              props.wireItem[index].chinese_name =
                result.QueryTableData.chinese_name;
              props.wireItem[index].furnaceCode =
                result.QueryTableData.furnaceCode;
              props.wireItem[index].org_code = result.QueryTableData.org_code;
              props.wireItem[index].orgScroll_no = scroll_no;

              var queryIndex =
                props.wireItem[index].reason.indexOf("scroll_no");
              if (props.wireItem[index].in_scroll_no != scroll_no) {
                if (queryIndex == -1) {
                  props.wireItem[index].reason.push("scroll_no");
                }
              } else {
                //舊的跟新的一樣
                if (queryIndex != -1) {
                  props.wireItem[index].reason.splice(queryIndex, 1);
                }
              }
            } else {
              methods.setTimeoutAlert(`查無此線材捲號，請再次確認`);
              props.wireItem[index].scroll_no =
                props.wireItem[index].orgScroll_no;
              return;
            }
          });
          break;
        case "consumption":
          console.log("consumption");
          let consumption = props.wireItem[index].consumption;
          if (consumption < 0 || consumption == "" || isNaN(consumption)) {
            props.wireItem[index].consumption =
              props.wireItem[index].orgConsumption;
            methods.setTimeoutAlert(`耗用量僅能是正數，請再次確認`);
            return;
          }
          props.wireItem[index].orgConsumption = consumption;

          var queryIndex = props.wireItem[index].reason.indexOf("consumption");
          if (props.wireItem[index].in_consumption != consumption) {
            if (queryIndex == -1) {
              props.wireItem[index].reason.push("consumption");
            }
          } else {
            //舊的跟新的一樣
            if (queryIndex != -1) {
              props.wireItem[index].reason.splice(queryIndex, 1);
            }
          }
          break;

        default:
          break;
      }
    };
    const onWireDeleteClicked = (index) => {
      props.wireItem.splice(index, 1);
    };
    const onWireAddClicked = () => {
      props.wireItem.push({
        index: "",
        in_scroll_no: "",
        scroll_no: "",
        orgScroll_no: "",
        code: "",
        chinese_name: "",
        furnaceCode: "",
        in_consumption: "",
        consumption: "",
        orgConsumption: "",
        org_code: "",
        reason: [],
        del: "",
      });
    };
    watch(
      () => props.modStatus,
      () => {
        setField();
      },
      { deep: true }
    );

    setField();

    return {
      wireTableFields,
      checkChangeInput,
      onWireDeleteClicked,
      onWireAddClicked,
    };
  },
};
</script>

<style>
.modWireTable table tbody tr:last-child td {
  border: none;
}
</style>
